if (!customElements.get('cl23-detail-model')) {
  customElements.define('cl23-detail-model', class extends HTMLElement {
    connectedCallback() {
      if (this.viewerUI) { this.observeReveal(); return; }
      if (!window.Shopify || !Shopify.loadFeatures) return;
      Shopify.loadFeatures([{ name: 'model-viewer-ui', version: '1.0', onLoad: (errors) => {
        if (errors || !this.isConnected || this.viewerUI) return;
        const viewer = this.querySelector('model-viewer');
        if (!viewer) return;
        this.viewerUI = new Shopify.ModelViewerUI(viewer, { focusOnPlay: false });
        this.dataset.ready = 'true';
        this.observeReveal();
      }}]);
    }
    observeReveal() {
      if (this.dataset.autoReveal !== 'true' || this.revealObserver) return;
      if (!('IntersectionObserver' in window)) { this.viewerUI.play(); return; }
      this.revealObserver = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          this.viewerUI.play();
          this.revealObserver.disconnect();
          this.revealObserver = null;
        }
      }, { threshold: 0.05 });
      this.revealObserver.observe(this);
    }
    disconnectedCallback() {
      if (this.revealObserver) { this.revealObserver.disconnect(); this.revealObserver = null; }
      if (this.viewerUI) this.viewerUI.pause();
    }
  });
}

